import React, { useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Button, Form } from 'react-bootstrap';

import { formatDate, _diff2Date } from 'utils';

import RenderDatePicker from 'components/input/renderDatePicker';
import { translate } from 'react-i18next';

import * as _ from 'lodash';
import { setToast } from 'containers/client/actions';
import { analLichSuGiaRequest } from 'containers/market/actions';
import { analLichSuGiaSuccess } from 'containers/market/actions';

function usePrevious(value) {
  const ref = useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function FormSearchTradeHis(props) {
  const dispatch = useDispatch();

  const refSubmit = useRef();

  const { symbol, startDate, endDate, lang } = props;

  const preSymbol = usePrevious(symbol);

  React.useEffect(() => {
    
    setTimeout(() => {
      handleSearch();
    }, 200);

    return () => {
      // cleanup
      dispatch(analLichSuGiaSuccess(null))
    }
  }, [])

  React.useEffect(() => {
    if(symbol && preSymbol && !_.isEqual(symbol, preSymbol)){
      handleSearch();
    }
  }, [symbol])

  function submit(values) {
    handleSearch();
  }

  function handleSearch() {
    const maxDay = 90;

    const d = new Date();
    d.setDate(d.getDate() - 30);
    const _endDate = endDate || formatDate(new Date(), '/', 'dmy');
    const _startDate = startDate || formatDate(d, '/', 'dmy');

    const _diff = _diff2Date(_endDate, _startDate);
    if (_diff < 0) {
      handleToast('Thời gian tìm kiếm không hợp lệ', 'error');
      return;
    }
    if (_diff > maxDay) {
      handleToast(
        'Chỉ được xuất báo cáo trong vòng ' + maxDay + ' ngày',
        'error'
      );
      return;
    }

    const params = {
      lang,
      secCode: symbol,
      startDate: _startDate.split('/').reverse().join('-'),
      endDate: _endDate.split('/').reverse().join('-'),
    };
    dispatch(analLichSuGiaRequest(params))
  }

  function handleToast(msg, type = 'info') {
    // log(msg)
    const toastMsg = {
      id: Math.random(),
      msg: msg,
      title: 'Thông báo',
      type,
    };
    dispatch(setToast(toastMsg));
  }

  const { handleSubmit, submitting, pristine, reset, t } = props;

  return (
    <form
      onSubmit={handleSubmit(submit)}
      className="d-flex w-100 form-search-head"
      style={{ padding: '8px 16px', marginBottom: '5px' }}
    >
      <Form.Group className="d-flex mb-0" controlId="formPlaintextSymbol">
        <label className="txt-content fz-13 pr-2 text-nowrap">{t('txt-label-from')}</label>
        <Field
          classname="form-control form-input fz-13"
          name="startDate"
          type="start"
          startDate={startDate}
          endDate={endDate}
          component={RenderDatePicker}
        />
        <label className="txt-content fz-13 ml-3 pr-2 text-nowrap">{t('txt-label-to')}</label>
        <Field
          classname="form-control form-input fz-13"
          name="endDate"
          type="end"
          startDate={startDate}
          endDate={endDate}
          component={RenderDatePicker}
        />

        <Button
          ref={refSubmit}
          type="submit"
          disabled={submitting}
          className="ml-2 text-nowrap font-weight-bold"
        >
          {t('txt-search')}
        </Button>
      </Form.Group>
    </form>
  );
}

FormSearchTradeHis = reduxForm({
  form: 'formsearchanalysistradehis',
  enableReinitialize: true,
})(FormSearchTradeHis);

const selector = formValueSelector('formsearchanalysistradehis');

const makeMapStateToProps = () => {
  const mapStateToProps = (state) => {
    const { startDate, endDate } = selector(state, 'startDate', 'endDate');

    const numDay = 30;

    const d = new Date();
    d.setDate(d.getDate() - numDay);

    return {
      lang: state.client?.setting?.lang || 'vi',
      startDate,
      endDate,
      initialValues: {
        endDate: formatDate(new Date(), '/', 'dmy'),
        startDate: formatDate(d, '/', 'dmy'),
      },
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(
  translate('translations')(FormSearchTradeHis)
);
